export const PUMA_APP_ID = '6f9cc01f-a3b8-46e3-881d-9e0d8ca0a0a7';
export const PUMA_MODULE_NAME = "DOLPHIN_STOW_";